import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions.js'
import getters from './getters.js'
import mutations from './mutations.js'
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie'

const state = {
  KP:{
    key: '1234567812345678', // 秘钥 16*n:
    iv: '1234567812345678'  // 偏移量
  },
  leadSteps: {
     firstStep:false,
     secondStep:false,
     thirdStep:false,
     fourthStep:false,
     fifthStep:false,
     sixthStep:false,
     maskStep:true
  },
  addTagInfo:{
    show:false,
    title:"添加快速菜单"
  },
  userStatus: {
    isLogin: '',
    examineStatus: '',
    justId: '',
    companyCompleteStatus: '',
    checkFlag: '',
    talkLater: '',
    regeisterType: '',
    exmaineMessage: ''
  },
  userInfo: {},
  workbenchCurrentStepSup: 0,
  workbenchCurrentStepPur: 0
}

Date.prototype.format = function(format) {
  var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
  };
  if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
               format = format.replace(RegExp.$1, RegExp.$1.length == 1
                      ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
  }
  return format;
}
Vue.filter('time', function (value) {
  let newDate = new Date(parseInt(value));
  if(value == ''){
    return '';
  }else{
    return newDate.format('yyyy-MM-dd hh:mm:ss');
  }
})
Vue.filter('timeDate', function (value) {
  let newDate = new Date(parseInt(value));
  if(value == ''){
    return '';
  }else{
    return newDate.format('yyyy-MM-dd');
  }
})


Vue.filter('substr', function (value) {
  if (!value) return ''
  if (value.length > 12) {
    return value.slice(0,12) + '...'
  }
  return value
})
// 协议类型 1000长期协议 2000折扣协议 3000框架协议
Vue.filter('getProtocolType', function (value) {
  let obj={
    '1000':'长期协议',
    '2000':'折扣协议',
    '3000':'框架协议'
  }
  return obj[value]
})
// 协议状态：1000-保存，审批中-1550，生效-2000，过期-3000
Vue.filter('getProtocolStatus', function (value) {
  let obj={
    '1000':'保存',
    '1500':'保存',
    '1550':'审批中',
    '2000':'生效',
    '3000':'过期'
  }
  return obj[value]
})
Vue.prototype.getNowFormatDate = function() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
};


Vue.prototype.transferDateTime = function (timestamp) {
  let date = new Date(Number(timestamp));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = (date.getDate() <10 ? '0'+date.getDate() : date.getDate())+ ' ';
  let h = date.getHours() + ':';
  let m = date.getMinutes() + ':';
  let s = date.getSeconds();
  return Y+M+D+h+m+s;
};

Vue.prototype.transferDate = function (timestamp) {
  let date = new Date(Number(timestamp));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = (date.getDate() <10 ? '0'+date.getDate() : date.getDate());
  return Y+M+D;
};

Vue.prototype.setToken = function (tokenName, tokenValue) {
  if (window.localStorage) {
    localStorage.setItem(tokenName, tokenValue);
  } else {
    alert('This browser does NOT support localStorage');
  }
};
Vue.prototype.getToken = function (name) {
  var token = '';
  if(name == 'isLogin'){
    token = Cookies.get('isLogin');
    if(token == null ){
      token = '';
    }
  }else{
    token = localStorage.getItem(name);
  }


  if (token) {
    return token;
  } else {
    return '';
  }
};
Vue.prototype.removeToken = function (name) {
  if (window.localStorage) {
    localStorage.removeItem(name);
  } else {
    alert('This browser does NOT support localStorage');
  }
};

Vue.prototype.setCookie = function (name,value) {
  Cookies.set(name,value,{domain:'.onelinkplus.com',expires:10});
};

Vue.prototype.getCookie = function (name) {
  var token = Cookies.get(name);
  if(token == null ){
    token = '';
  }
  if (token) {
    return token;
  } else {
    return '';
  }
};

Vue.prototype.removeCookie = function (name) {
  Cookies.remove(name);
};

Vue.prototype.getAesString  = function (data, key, iv) { // 加密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  let encrypted = CryptoJS.AES.encrypt(data, key,
      {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
  return encrypted.toString();    // 返回的是base64格式的密文
};
Vue.prototype.getDAesString  = function(encrypted, key, iv) { // 解密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  let decrypted = CryptoJS.AES.decrypt(encrypted, key,
      {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
  return decrypted.toString(CryptoJS.enc.Utf8);      //
};

Vue.prototype.openFullScreen = function(time) {
  const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
  });
  setTimeout(()=>loading.close() , time)
};

Vue.prototype.getUrlKey = function (name,url) {
  return decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

Vue.prototype.antiCreeping = function (value,flag) {
  let arr = value.split('');
  let numObj={d:'78',0:'e9d5',1:'f8a9',2:'e8e3',3:'e272',4:'e389',5:'f868',6:'ef3a',7:'f672',8:'e06f',9:'f378'}
  if(flag){
    let newDate = new Date(parseInt(value));
    let date =flag+newDate.format('yyyy-MM-dd hh:mm:ss');
    if(flag == ' '){
      date =newDate.format('yyyy-MM-dd');
    }
    arr = date.split('')
  }
  arr.forEach((item,index)=>{
    let b = /\d/;
    if(b.test(item)){
      arr[index] = '<e class="iconfont">&#x'+numObj[item]+'</e>';
    }else{
      arr[index] = item+'<d class="'+Math.random().toString(36).substr(2)+'"></d>';
    }
  })
  return arr.join('<e class="'+Math.random().toString(36).substr(2)+'"></e>')
}

Vue.use(Vuex)


export default new Vuex.Store({
  // 定义状态
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js